import { ComponentSettingsVariables } from "@intelligems/ig-widgets/ProgressBarView/util/textVariables";

export function fromMentionsVariables(
  text: string,
  variables: ComponentSettingsVariables[]
) {
  let result = text || "";
  for (const variable of variables) {
    result = result.replaceAll(
      `@[${variable.display}](#${variable.id})`,
      `#${variable.id}`
    );
  }
  return result;
}

export function toMentionsVariables(
  text: string,
  variables: ComponentSettingsVariables[]
) {
  let result = text || "";
  for (const variable of variables) {
    result = result.replaceAll(
      `#${variable.id}`,
      `@[${variable.display}](#${variable.id})`
    );
  }
  return result;
}
